import { loadPageJavascript } from "../../lib/browser-hacks";
import { sleep } from "common/Support";
import { getLocationSettings } from "../../lib/location";

let globalClient: any = undefined;

export async function initChargebee(): Promise<any> {
    if (globalClient !== undefined) {
        return globalClient;
    }

    const site = getLocationSettings().chargebeeSite;

    loadPageJavascript("https://js.chargebee.com/v2/chargebee.js", e => e.setAttribute("data-cb-site", site));

    while ((window as any).Chargebee === undefined) {
        await sleep(500);
    }

    globalClient = (window as any).Chargebee.getInstance();
    return globalClient;
}
